import Logo from 'components/logo/Logo';
import styled, { keyframes } from 'styled-components';

const circleRadius = 20;

const LoadingPage = () => (
  <Wrapper>
    <LogoWrapper>
      <Logo />
    </LogoWrapper>
    <Circle1 />
    <Circle2 />
    <Circle3 />
  </Wrapper>
);

export default LoadingPage;

const LogoWrapper = styled.div`
  max-width: 250px;
  width: 100%;
  margin-bottom: 140px;
`;

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const glider = keyframes`
    0% { margin-left:  ${-0.5 * circleRadius}px; }
    50% { margin-left: ${0.5 * circleRadius}px; }
    100% { margin-left: ${-0.5 * circleRadius}px; }
`;

const farGlider = keyframes`
    0% { margin-left: ${-circleRadius}px; }
    50% { margin-left: ${circleRadius}px; }
    100% { margin-left: ${-circleRadius}px; }
`;

const Circle1 = styled.div`
  background: #17d7e0;
  width: ${circleRadius}px;
  height: ${circleRadius}px;
  border-radius: 100%;
  position: absolute;
  margin-left: -15px;
  animation: ${farGlider};
  animation-duration: 1.2s;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
`;

const Circle2 = styled.div`
  background: #268eb3;
  width: ${circleRadius}px;
  height: ${circleRadius}px;
  border-radius: 100%;
  position: absolute;
  animation-name: ${glider};
  animation-duration: 1.2s;
  animation-timing-function: cubic-bezier(0.63, 0.62, 0.32, 1.28);
  animation-iteration-count: infinite;
`;

const Circle3 = styled.div`
  background: #113a49;
  width: ${circleRadius}px;
  height: ${circleRadius}px;
  border-radius: 100%;
  position: absolute;
`;
